<template>
  <ak-overlay v-if="surveyUrl" class="h-full bt">
    <iframe :src="surveyUrl" class="h-full" />
    <template #overlayBody>
      <div class="text-center">
        <ak-button :href="editUrl" tag="a" target="_blank" size="large">
          Edit
        </ak-button>
      </div>
    </template>
  </ak-overlay>
</template>

<script>
import { defineComponent, computed, onMounted } from 'vue'
import Overlay from '@akerolabs/akero-vue/src/components/overlay/Overlay.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import { setTabHistory } from '../utils'
export default defineComponent({
  name: 'PreviewIframe',
  components: {
    [Overlay.name]: Overlay,
    [Button.name]: Button,
  },
  props: {
    /**
     * @description the survey url
     * @type {String}
     */
    surveyUrl: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    /**
     * @description Try and make an edit survey url from the survey-gizmo url
     * @type {String}
     */
    const editUrl = computed(() => {
      if (!props.surveyUrl) return ''
      const urlSplit = props.surveyUrl
        .replace('https://', '')
        .replace('http://', '')
        .split('/')
      if (urlSplit.length === 4) {
        const host = urlSplit[0]
        const id = urlSplit[2]
        const domain = host.substring(host.lastIndexOf('.') + 1)
        return `https://app.alchemer.${domain}/builder/build/id/${id}`
      }
      return ''
    })
    onMounted(() => {
      setTabHistory('preview')
    })
    return {
      editUrl,
    }
  },
})
</script>
